import {
  CHART_MAX_SERIES,
  CHART_PALETTE_NEGATIVE,
  CHART_PALETTE_POSITIVE,
} from './chart-tokens';

const clampSeriesCount = (seriesCount: number): 1 | 2 | 3 => {
  if (seriesCount <= 1) return 1;
  if (seriesCount >= CHART_MAX_SERIES) return 3;

  return 2;
};

/** Picks the swatch color for a series at a given ramp position. */
export const colorForSeries = (
  seriesIndex: number,
  seriesCount: number,
  isNegative: boolean
): string => {
  const palette = isNegative ? CHART_PALETTE_NEGATIVE : CHART_PALETTE_POSITIVE;
  const ramp = palette[clampSeriesCount(seriesCount)];

  return ramp[seriesIndex % ramp.length];
};

/** Picks the bar fill color; sign of `value` selects the ramp. */
export const colorForBar = (
  seriesIndex: number,
  seriesCount: number,
  value: number | null
): string =>
  colorForSeries(
    seriesIndex,
    seriesCount,
    typeof value === 'number' && value < 0
  );
